import React from 'react'
import { ContentItemObject } from 'routes/content-management/ContentManagement/ContentManagementProvider/Context'

interface IErrorsObj {
  [key: string]: string | undefined
}

interface IContext {
  scid?: number
  show: boolean
  onHideModal: () => void
  onSaveItem: () => void
  onDeleteItem: () => void
  isEditing: boolean
  item: ContentItemObject
  type?: string
  setImageUploadOpen: (open: boolean) => void
  onUpdateField: (field: string, value: any) => void
  onUpdateFields: (fields: { [key: string]: any }) => void
  validation: {
    errors: IErrorsObj
    hasErrors: boolean
    getError: (field: string) => string | undefined
    clearErrors: (fieldNames: any) => void
    getHasError: (field: string) => boolean
    calculateErrors: (valuesByError: { [key: string]: any }) => {
      errors: string[]
      hasErrors: boolean
    }
    setError: (field: string, error?: any) => void
  }
  selectedAcademicFocuses?: string[]
  setSelectedAcademicFocuses: (selectedAcademicFocuses: string[]) => void
  selectedCategories?: string[]
  setSelectedCategories: (selectedCategories: string[]) => void
  exceed5Tags?: boolean
  setExceed5Tags: (exceed5Tags: boolean) => void
}

const ctx: IContext = {
  show: false,
  onHideModal: () => {},
  onSaveItem: () => {},
  onDeleteItem: () => {},
  isEditing: false,
  item: {} as ContentItemObject,
  setImageUploadOpen: () => {},
  onUpdateField: () => {},
  onUpdateFields: () => {},
  validation: {
    errors: {},
    hasErrors: false,
    getError: () => undefined,
    clearErrors: () => {},
    getHasError: () => false,
    calculateErrors: () => ({ errors: [], hasErrors: false }),
    setError: () => {},
  },
  setSelectedAcademicFocuses: () => {},
  setSelectedCategories: () => {},
  setExceed5Tags: () => {},
}

export default React.createContext(ctx)
